import { useState } from "react";
import { motion } from "framer-motion";
import SectionLabel from "../components/SectionLabel";
import FloatingVideo from "../components/FloatingVideo";
import { SELECTED_WORK } from "../data/site";

export default function SelectedWork({ onOpen }) {
  const [hover, setHover] = useState(null);
  const active = SELECTED_WORK.find((w) => w.id === hover);

  return (
    <section id="work" className="relative px-6 md:px-12 lg:px-16 py-32 md:py-48" data-testid="selected-work">
      <FloatingVideo src={active ? active.video : null} vertical />

      <SectionLabel index="03">SELECTED WORK</SectionLabel>

      <div className="mt-16 border-t border-white/[0.08]">
        {SELECTED_WORK.map((w) => (
          <motion.button
            key={w.id}
            onMouseEnter={() => setHover(w.id)}
            onMouseLeave={() => setHover(null)}
            onClick={() => onOpen(w.id)}
            data-cursor="VIEW"
            data-testid={`work-row-${w.id}`}
            className="group flex w-full flex-col gap-3 border-b border-white/[0.08] py-8 text-left transition-opacity duration-500 md:flex-row md:items-baseline md:justify-between md:py-10"
            animate={{ opacity: hover && hover !== w.id ? 0.3 : 1 }}
          >
            <div className="flex items-baseline gap-6">
              <span className="label text-lav-400/70 hidden md:inline">↗</span>
              <span className="text-big uppercase leading-none transition-transform duration-500 group-hover:translate-x-3 group-hover:text-lav-400">
                {w.client}
              </span>
            </div>
            <div className="flex items-center gap-8 md:gap-16">
              <span className="label text-white/45">{w.category}</span>
              <span className="label text-white/45 hidden lg:inline">{w.year}</span>
              <span className="label text-white/80 whitespace-nowrap">{w.result}</span>
            </div>
          </motion.button>
        ))}
      </div>
    </section>
  );
}
